import { ref, type Ref } from 'vue';

import { createSingleton } from '../utils';

export const useWindow = createSingleton((): {
    windowHeight: Ref<number>;
    windowWidth: Ref<number>;
    windowScroll: Ref<number>;
} => {
    const windowHeight = ref(window.innerHeight);
    const windowWidth = ref(window.innerWidth);
    const windowScroll = ref(window.scrollY);

    window.addEventListener('resize', (): void => {
        windowHeight.value = window.innerHeight;
        windowWidth.value = window.innerWidth;
    });

    window.addEventListener('scroll', (): void => {
        windowScroll.value = window.scrollY;
    });

    return {
        windowHeight,
        windowWidth,
        windowScroll
    };
});